@if (selected && hasItems()) {
  <ul ngbNav [(activeId)]="selected.id" class="nav-tabs mb-2">
    @for (item of items; track item.id) {
      <li [ngbNavItem]="item.id" class="nav-item">
        @if (item.hasTranslation()) {
          <a ngbNavLink class="nav-link btn btn-sm" [class.disabled]="disabled"
             (click)="selectItem(item)" (keydown.enter)="selectItem(item)" tabindex="0">
            {{ item.translation | translate }}
          </a>
        } @if (!item.hasTranslation()) {
        <a ngbNavLink class="nav-link btn btn-sm" [class.disabled]="disabled"
           (click)="selectItem(item)" (keydown.enter)="selectItem(item)" tabindex="0">
          {{ item.name }}
        </a>
      }
      </li>
    }
  </ul>
}
